import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import ordersDetailsData from "./data/orderDetailsData"
import AuthService from "services/AuthService";

function OrdersDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pw } = location.state || {};
  const { id } = useParams();

  const currentUser = AuthService.getCurrentUser();

  if (currentUser === null && !pw) {
    navigate(`/access-order/${id}`);
  }

  const data = ordersDetailsData(id, pw);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Detalhes do pedido
                  </MDTypography>
                </MDBox>
              </MDBox>
              {data}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OrdersDetails;
